import AxilocSettingForm from '@/components/AxilocSetting/AxilocSettingForm'

let AxilocSettingRouter = [{
  path: '/axiloc_setting',
  name: 'AxilocSettingEdit',
  component: AxilocSettingForm,
  meta: {
    title: 'Paramètres boutique',
    requiresAuth: true,
    authorizations: ['axiloc-setting_edit', 'desktop_access']
  }
}]

export default AxilocSettingRouter



// WEBPACK FOOTER //
// ./src/components/AxilocSetting/router.js